<template>
    <div class="g-content g-autofixheight order-detail">
        <div class="order-message f-clearfix">
            <img
                class="order-detail-header f-fl"
                :src="demandItemInfo.gameLogo"
                width="80"
                height="80"
            >
            <div class="order-detail-intro f-fr">
                <div class="order-name-contain f-clearfix">
                    <span class="order-name f-hide-col-1">{{ demandItemInfo.demandItemName }}</span>
                    <!--<span class="status-r f-fr back-btn" @click="goBack">返回</span>-->
                    <span class="status f-fr">{{ demandItemInfo.statusText }}</span>
                </div>
                <div class="order-lines order-num-line">
                    <div class="order-num">
                        单号:
                        <span class="order-num-detail">{{ demandItemInfo.id }}</span>
                    </div>
                    <div class="budget-all" style="width: 200px">
                        含税总预算:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandItemInfo.initialTaxableTotalBudget) }}
                        </div>
                    </div>
                    <div class="budget-all">
                        税后实收:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandItemInfo.initialTotalBudget) }}
                        </div>
                        <div class="ask-ico">
                            <div class="answer-show">
                                <i class="triangle"></i>
                                <div
                                    class="answer-text"
                                >税费￥ {{ $common.toThousandsFilter(demandItemInfo.initialTax) }} 已由腾讯公司代缴</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-type-line">
                    <div class="order-num">
                        类型:
                        <span class="order-num-detail">{{ demandItemInfo.demandTypeText }}</span>
                    </div>
                    <div class="budget-all" style="width: 200px">
                        含税实际额:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandItemInfo.taxableTotalBudget) }}
                        </div>
                    </div>
                    <div class="budget-all">
                        税后实收:
                        <div class="budget-all-num">
                            <span class="money-ico">￥</span>
                            {{ $common.toThousandsFilter(demandItemInfo.totalBudget) }}
                        </div>
                        <div class="ask-ico">
                            <div class="answer-show">
                                <i class="triangle"></i>
                                <div
                                    class="answer-text"
                                >税费￥ {{ $common.toThousandsFilter(demandItemInfo.tax) }} 已由腾讯公司代缴</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-lines order-time-line">
                    <div class="order-num">
                        时间:
                        <span
                            class="order-num-detail"
                        >{{ demandItemInfo.startTime }}~{{ demandItemInfo.endTime }}</span>
                    </div>
                    <div class="budget-all">
                        内容形式:
                        <span class="budget-all-num">{{ demandItemInfo.demandItemTypeText }}</span>
                    </div>
                </div>
                <div class="order-lines order-tips-line">
                    <div class="order-num">
                        说明:
                        <span
                            class="order-num-detail f-hide-col-1"
                        >{{ demandItemInfo.description }}</span>
                    </div>
                    <div class="budget-all">
                        验收要求:
                        <span
                            class="budget-all-num f-hide-col-1"
                            :title="demandItemInfo.approverProve"
                        >{{ demandItemInfo.approverProve }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="commit-task g-autofixheight">
            <!-- 选项卡[[ -->
            <div class="g-tab">
                <a href="javascript:;">
                    <div class="g-tab-item g-tab-item-active">已提交任务</div>
                </a>
            </div>
            <!-- 选项卡]] -->
            <div class="order-detail-status-1">
                <div class="searchs-list">
                    <div class="search f-clearfix">
                        <!-- 7.18修改 -->
                        <select-box
                            :selectList="pageConf.contentTypeList"
                            :itemTitle="'内容类型'"
                            :selected.sync="params.type"
                        ></select-box>
                        <select-box
                            :selectList="pageConf.articleStatusList"
                            :itemTitle="'内容状态'"
                            :selected.sync="params.status"
                        ></select-box>
                        <div class="list f-fl list-title">
                            <p class="name f-fl">
                                <label for="keyword">内容标题</label>
                            </p>
                            <div class="g-select f-fl">
                                <input
                                    class="input"
                                    name="keyword"
                                    type="text"
                                    placeholder="请输入要搜索的标题"
                                    v-model="params.title"
                                >
                                <!--0629修改-->
                            </div>
                        </div>
                        <div class="inquire f-fr">
                            <input class="btn" type="button" value="查询" @click="getList">
                        </div>
                    </div>
                    <ul class="freelance-list">
                        <li
                            class="list"
                            v-for="(article,index) in demandItemArticleList"
                            :key="index"
                        >
                            <div class="f-clearfix">
                                <p class="pic f-fl">
                                    <img :src="article.cover" width="197" height="111" alt>
                                </p>
                                <div class="txt f-fl">
                                    <!-- 不带原创标签[[ -->
                                    <h3 class="title">
                                        <span class="type">【{{ article.articleTypeText }}】</span>
                                        <a
                                            class="name f-hide-col-1 js-open-view"
                                            href="javascript:;"
                                            @click="previewArticle(article)"
                                        >{{ article.articleTitle }}</a>
                                    </h3>
                                    <!-- 不带原创标签]] -->
                                    <div class="intro">{{article.gameName}}</div>
                                    <p class="author">
                                        {{ article.userName }}
                                        <span
                                            class="time"
                                        >{{ article.created}}</span>
                                    </p>
                                </div>
                                <div class="examine f-fl">
                                    <a
                                        class="switch js-down1"
                                        href="javascript:;"
                                        @click="article.showMediaDistribute = !article.showMediaDistribute"
                                    >
                                        发布渠道
                                        <i
                                            class="ico"
                                            :class="article.showMediaDistribute ? 'ico-up' : 'ico-down'"
                                        ></i>
                                    </a>
                                </div>
                                <!-- 已驳回  一行文本[[ -->
                                <div
                                    class="operation reject-one f-fr"
                                    v-if="article.articleStatus == 50 && article.reject_remark.length < 20"
                                >
                                    <p class="status">
                                        <span class="color-theme">{{ article.articleStatusText }}</span>
                                    </p>
                                    <p class="reject-text">{{article.reject_remark}}</p>
                                </div>
                                <div
                                    class="operation reject-more f-fr"
                                    v-else-if="article.articleStatus == 50 && article.reject_remark.length >= 20"
                                >
                                    <p class="status">
                                        <span class="color-theme">{{ article.articleStatusText }}</span>
                                    </p>
                                    <p
                                        class="reject-text f-hide-col-4"
                                    >{{article.reject_remark.slice(0,20)}}</p>
                                    <!-- 交互说明：光标进入出现 -->
                                    <p class="all">
                                        <i class="triangle"></i>
                                        {{article.reject_remark}}
                                    </p>
                                </div>
                                <div class="operation wait-accept f-fr" v-else>
                                    <p class="status">
                                        <span class="color-theme">{{ article.articleStatusText }}</span>
                                    </p>
                                </div>
                                <!-- 已驳回  一行文本]] -->
                            </div>
                            <ul
                                class="channel f-clearfix js-channel-show1"
                                style="display: block"
                                v-if="article.showMediaDistribute"
                            >
                                <li
                                    class="item f-fl"
                                    v-for="(media,index) in article.media"
                                    :key="index"
                                >
                                    <span class="head">
                                        <img :src="media.outCover" width="25" height="25">
                                    </span>
                                    <a
                                        class="name js-open-channel"
                                        href="javascript:;"
                                        style="width: 6rem"
                                        @click="showMediaDistributeDialog(media)"
                                        @mouseenter="media.showRemark = true"
                                        @mouseleave="media.showRemark = false"
                                    >{{ media.accountName }}</a>

                                    <span class="sync sync-success" v-if="media.status==1">
                                        同步
                                        <i class="ico ico-success"></i>
                                    </span>
                                    <span class="sync sync-failure" v-else-if="media.status==0">
                                        未同步
                                        <i class="ico ico-failure"></i>
                                    </span>
                                    <span class="sync sync-failure" v-else-if="media.status==3">
                                        同步失败
                                        <i class="ico ico-failure"></i>
                                    </span>
                                    <div
                                        class="sync-failure-reason"
                                        style="display: block"
                                        v-if="media.showRemark && media.remark"
                                    >
                                        <div class="sync-failure-triangle"></div>
                                        <div
                                            class="failure-reason-text f-hide-col-1"
                                        >{{media.remark}}</div>
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <!-- 空数据 start -->
                    <div class="empty" v-if="demandItemArticleList.length== 0">
                        <img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png">
                    </div>
                    <!-- 空数据 end -->
                </div>
                <!--根据-->
                <div class="footer-bar">
                    <div class="footer-bar-btn">
                        <div class="g-bottom-btn btn-group">
                            <a class="button f-fr" href="javascript:;" @click="goBack">返回</a>
                            <!--选中状态  为a标签添加类 active -->
                            <a
                                class="button active f-fr"
                                href="javascript:;"
                                v-if="showContributeBtn"
                                @click="contribute"
                            >投稿</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 分页[[ -->
            <pagination
                v-if="paginationConf.total >0"
                :total="paginationConf.total"
                :page-size="paginationConf.pageSize"
                @change="pageChange"
                ref="pager"
            ></pagination>
            <!-- 分页]] -->
        </div>
        <!--内容预览 start-->
        <content-preview ref="contentPreview"></content-preview>
        <video-preview ref="videoPreview"></video-preview>
        <!--内容预览 end-->
        <media-distribute-info ref="mediaDistributeInfo"></media-distribute-info>
    </div>
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/order/order_detail.scss";
.back-btn {
    display: inline-block;
    vertical-align: top;
    width: auto;
    height: 30px;
    margin: 0 10px 0 30px;
    padding: 0 30px;
    border: 1px solid #fd7e28;
    border-radius: 2px;
    line-height: 30px;
    font-size: 14px;
    background: #fd7e28;
    color: #fff;
    cursor: pointer;
}
.status-r {
    display: inline-block;
    font-size: 14px;
}
</style>

<script>
import selectBox from "Components/v4/dropdown/select_box";
import pagination from "Components/v4/pagination/pagination_v4";
import contentPreview from "Components/v4/pop/content_preview";
import videoPreview from "Components/v4/pop/video_preview";
import mediaDistributeInfo from "../supplier_order/media_distribute_info";
import {
    PersonDemandAttachments,
    PersonDemandArticleList,
    PersonDemandItemInfo
} from "Services/getData.js";
import { ARTICLE_TYPE_LIST } from "Services/paramsConfig.js";
export default {
    name: "person_order_detail.vue",
    data() {
        return {
            params: {
                demandItemId: "",
                type: "",
                status: "",
                title: "",
                page: 1,
                pageSize: 10
            },
            pageConf: {
                demandTypeList: [
                    {
                        name: "内容创作",
                        id: 10
                    },
                    {
                        name: "劳务服务",
                        id: 20
                    },
                    {
                        name: "福利奖金",
                        id: 30
                    },
                    {
                        name: "补贴补偿",
                        id: 40
                    }
                ],
                contentTypeList: [
                    {
                        name: "全部",
                        id: ""
                    },
                    {
                        name: "图文",
                        id: 0
                    },
                    {
                        name: "视频",
                        id: 1
                    },
                    {
                        name: "小说",
                        id: 50
                    },
                    {
                        name: "漫画",
                        id: 60
                    }
                ],
                articleStatusList: [
                    {
                        name: "全部",
                        id: ""
                    },
                    {
                        name: "草稿中",
                        id: 0
                    },
                    {
                        name: "待审核",
                        id: 10
                    },
                    {
                        name: "外团已通过",
                        id: 15
                    },
                    {
                        name: "供应商已通过",
                        id: 18
                    },
                    {
                        name: "已通过",
                        id: 20
                    },
                    {
                        name: "已发布",
                        id: 30
                    },
                    {
                        name: "已驳回",
                        id: 50
                    },
                    {
                        name: "已删除",
                        id: 70
                    }
                ],
                demandItemList: [],
                demandItemMap: {}
            },
            demandItemInfo: {},
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            demandItemArticleList: []
        };
    },
    components: {
        selectBox,
        pagination,
        contentPreview,
        videoPreview,
        mediaDistributeInfo
    },
    created() {},
    mounted() {
        this.demandItemInfo = this.$route.params;
        let { id } = this.$route.query;
        if (id) {
            this.demandItemInfo.id = id;
            this.getList();
        } else {
            this.$router.history.push({
                name: "v4-order-order"
            });
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        getList() {
            // 根据demandItemType 显示列表：文件、附件
            this.getPersonDemandItemInfo(this.demandItemInfo.id);
            this.getDemandItemArticles();
        },
        pageChange(param) {
            // this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.page = param.pageIndex; // 发送给接口的字段
            this.getDemandItemArticles();
        },
        showMediaDistributeDialog(media) {
            this.$refs.mediaDistributeInfo.show(media);
        },
        previewArticle(article) {
            if (parseInt(article.articleType) === 1) {
                this.$refs.videoPreview.remotePreview(article.id);
            } else {
                this.$refs.contentPreview.loadInfo(article.id);
            }
        },
        contribute() {
            this.$router.history.push({
                name: "v4-order-contribute",
                query: {
                    demandItemId: this.demandItemInfo.id,
                    demandType: 1
                }
            });
        },
        async getPersonDemandItemInfo(demandItemId) {
            let res = await PersonDemandItemInfo({
                demandItemId
            });
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    let demandItem = res.data.data;
                    if (this.demandTypeListMap.has(demandItem.demandType)) {
                        demandItem.demandTypeText = this.demandTypeListMap.get(
                            demandItem.demandType
                        );
                    }
                    this.demandItemInfo = demandItem;
                }
            }
        },
        async getDemandItemArticles() {
            // demandItemId = 123456;
            this.params.demandItemId = this.demandItemInfo.id;
            let param = this.params;
            let articleStatusMap = this.objToStrMap(
                this.pageConf.articleStatusList
            );
            let articleTypeMap = this.objToStrMap(ARTICLE_TYPE_LIST);

            let res = await PersonDemandArticleList(param);
            let data = res.data;
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    this.demandItemArticleList = data.data.data.map(article => {
                        if (articleStatusMap.has(article.articleStatus)) {
                            article.articleStatusText = articleStatusMap.get(
                                article.articleStatus
                            );
                        }
                        article.articleTypeText = articleTypeMap.get(
                            article.articleType
                        );
                        article.showMediaDistribute = false;
                        if (article.mediaDistribute) {
                            article.mediaDistribute.map(media => {
                                media.showRemark = false;
                                return media;
                            });
                        }
                        return article;
                    });
                    this.paginationConf.total = data.data.total;
                }
            }
        },
        objToStrMap(obj) {
            let strMap = new Map();
            for (let v of Object.values(obj)) {
                strMap.set(v.id, v.name);
            }
            return strMap;
        }
    },
    computed: {
        showContributeBtn() {
            let showBtnStatus = [3004, 3006];
            if (showBtnStatus.includes(this.demandItemInfo.demandItemStatus)) {
                return true;
            }
            return false;
        },
        demandTypeListMap() {
            let demandTypeListMap = new Map();
            for (let obj of this.pageConf.demandTypeList) {
                demandTypeListMap.set(obj.id, obj.name);
            }
            return demandTypeListMap;
        }
    }
};
</script>

